import { DIALOG_IDS } from "./dialog-ids";
import { AppDialogRegistry, DialogRegistry } from "./types";
import { withLazyDialog } from "./with-lazy-dialog";
import { APP_IDS, AppId } from "../../utils/app-ids";

const GuardianObjectPickerDialog = withLazyDialog(
  () => import("../../guardian-components/dialogs/ObjectPickerModal")
);

const AdministratorObjectPickerDialog = withLazyDialog(
  () => import("../../admin-components/dialogs/ObjectSelectionDialog/ObjectSelectionDialog")
);

const guardianDialogs: AppDialogRegistry = {
  [DIALOG_IDS.OBJECT_PICKER_DIALOG]: {
    component: GuardianObjectPickerDialog,
  },
};

const administratorDialogs: AppDialogRegistry = {
  [DIALOG_IDS.OBJECT_PICKER_DIALOG]: {
    component: AdministratorObjectPickerDialog,
  },
};

const emptyDialogs: AppDialogRegistry = {};

const getAppDialogRegistry = (appId: AppId | null): AppDialogRegistry => {
  if (appId === APP_IDS.GUARDIAN) {
    return guardianDialogs;
  }

  if (appId === APP_IDS.ADMINISTRATOR) {
    return administratorDialogs;
  }

  return emptyDialogs;
};

const buildDialogRegistry = (registry: AppDialogRegistry): DialogRegistry => {
  const dialogs: Partial<Record<string, DialogRegistry[keyof DialogRegistry]>> = {};

  (Object.keys(registry) as Array<keyof AppDialogRegistry>).forEach((dialogId) => {
    const entry = registry[dialogId];

    if (!entry) {
      return;
    }

    dialogs[dialogId] = entry.component;
  });

  return dialogs;
};

export const getDialogRegistry = (appId: AppId | null): DialogRegistry => {
  return buildDialogRegistry(getAppDialogRegistry(appId));
};
